import API from '@/api/callApi.js';
import endpoints from '@/api/endpoints';

export default {
    namespaced: true,
    state: {

        analytics: {
            loaded: false,
            loading: false,
            data: {},
            error: null
        },

        stats: {
            loaded: false,
            loading: false,
            data: {
                totals:{
                    time_in_store:{
                        houres: "01",
                        minutes: "13",
                        seconds: "07"
                    }
                }
            },
            error: null
        },
        consumedSources: {
            sms: 33,
            mails: 2
        },

        timeInEtablishment: '00 : 45 : 33',
        nbCustomerRegister: '56',
        nbAgainCustomerRegister: '49',
        compare: {
            periode1: {
                globalTime: '00 : 23 : 29',
                customerRegister: '43',
                customerReRegister: '36'
            },
            periode2: {
                globalTime: '00 : 45 : 25',
                customerRegister: '56',
                customerReRegister: '49'
            }
        }
    },
    mutations: {
        setAnalytics(state, {prop, value}) {
            state.analytics[prop] = value;
        },
        setStats(state, {prop, value}) {
            state.stats[prop] = value;
        },
        setConsumedSources(state, {prop, value}) {
            state.consumedSources = value
        }
    },
    getters: {
        consumedSources(state) {
            return state.consumedSources
        }
    },
    actions: { /*
        ** Test, should be erased
        */

        loadAnalytics(
            {
                state,
                commit
            },
            parameters
        ) {

            if (state.analytics.loading) {
                return;
            }

            commit('setAnalytics', {
                prop: 'loading',
                value: true
            });

            API.makeGet(endpoints.baseURL + endpoints.endpoints.getDashboardMain, null, true).then(response => {
                commit('setAnalytics', {
                    prop: 'data',
                    value: response.data.payload
                });

                if ('success' in parameters) {
                    parameters.success(response);
                }

                commit('setAnalytics', {
                    prop: 'loaded',
                    value: true
                });
            }).catch(error => {
                commit('setAnalytics', {
                    prop: 'error',
                    value: error
                });
            }). finally(response => {
                commit('setAnalytics', {
                    prop: 'loading',
                    value: false
                });
            });

        },

        /*
        ** DASHBOARD : GET STATS
        */

        loadStats(
            {
                state,
                commit
            },
            parameters
        ) {

            if (state.stats.loading) {
                return;
            }

            commit('setStats', {
                prop: 'loading',
                value: true
            });

            let params = {};

            if ('query' in parameters) {
                if ('from' in parameters.query) {
                    params.from = parameters.query.from;
                }
                if ('to' in parameters.query) {
                    params.to = parameters.query.to;
                }
            }

            API.makeGet(endpoints.baseURL + endpoints.endpoints.getDashboardStats, params, true).then(response => {
                commit('setStats', {
                    prop: 'data',
                    value: response.data.payload
                });
                commit('setStats', {
                    prop: 'loaded',
                    value: true
                });
            }).catch(error => {
                commit('setStats', {
                    prop: 'error',
                    value: error
                });
            }). finally(response => {
                commit('setStats', {
                    prop: 'loading',
                    value: false
                });
            });

        }
    }
}
